
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"800","height":"800","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 4a2 2 0 112.75 1.855v5.395h6.5V5.855a2 2 0 111.5 0v5.395H16c.964 0 1.612-.002 2.095-.066.461-.063.659-.17.789-.3.13-.13.237-.328.3-.79.064-.482.066-1.13.066-2.094V5.855a2 2 0 111.5 0v2.197c0 .898 0 1.648-.08 2.242-.084.628-.27 1.195-.726 1.65-.455.456-1.022.642-1.65.726-.594.08-1.343.08-2.242.08H12.75v5.395a2 2 0 11-1.5 0V12.75h-6.5v5.395a2 2 0 11-1.5 0V5.855A2 2 0 012 4z","fill":"#1C274C"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.25 15a.75.75 0 01.75-.75h2.286c1.375 0 2.464 1.134 2.464 2.5a2.502 2.502 0 01-1.641 2.358l1.53 2.5a.75.75 0 11-1.279.784l-1.923-3.142h-.687V22a.75.75 0 01-1.5 0v-7zm1.5 2.75h1.536c.518 0 .964-.433.964-1s-.446-1-.964-1H18.75v2z","fill":"#1C274C"}})])
          )
        }
      }
    